module.exports = __webpack_public_path__ + "img/Frame-19.233f7a3b.svg";